import { Drawer, DrawerProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { CloseIcon } from 'assets/icons/CloseIcon';
import { IconButton } from 'components/IconButton/IconButton';
import { ReactNode } from 'react';

import {
  getDrawerPaperSx,
  SidePanelHeader,
  TitleIconAndTitleContainer,
  TitleIconContainer,
} from './SidePanel.style';
type AnchorPosition = 'left' | 'top' | 'right' | 'bottom';
type SidePanelProps = {
  title: string;
  titleIcon?: JSX.Element;
  isOpen: boolean;
  onClose?: () => void;
  children: ReactNode;
  widthInPercent?: number;
  anchor?: AnchorPosition;
  isMobile?: boolean;
  drawerClasses?: DrawerProps['classes'];
  isHamburgerPanel?: boolean;
  paperSx?: SxProps<Theme>;
  zIndex?: number;
};
export const SidePanel = ({
  title,
  titleIcon,
  isOpen,
  onClose,
  children,
  widthInPercent,
  anchor = 'right',
  isMobile = false,
  drawerClasses,
  isHamburgerPanel = false,
  paperSx: additionalPaperSx,
  zIndex,
}: SidePanelProps): JSX.Element => {
  const basePaperSx = getDrawerPaperSx({ widthInPercent, isMobile });
  const combinedPaperSx: SxProps<Theme> = additionalPaperSx
    ? ([basePaperSx, additionalPaperSx].flat() as SxProps<Theme>)
    : basePaperSx;
  return (
    <Drawer
      classes={drawerClasses}
      PaperProps={{ sx: combinedPaperSx }}
      open={isOpen}
      anchor={anchor}
      onClose={onClose}
      sx={zIndex !== undefined ? { zIndex } : undefined}
    >
      <SidePanelHeader>
        <TitleIconAndTitleContainer>
          <TitleIconContainer>{titleIcon}</TitleIconContainer>
          {title}
        </TitleIconAndTitleContainer>

        {onClose && (
          <div
            style={
              isHamburgerPanel
                ? { position: 'absolute', top: '8px', right: '16px' } // <-- conditionally apply here
                : {}
            }
          >
            <IconButton size="medium" displayStyle="grey" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
        )}
      </SidePanelHeader>
      {children}
    </Drawer>
  );
};
